"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconPaste = function SvgIconPaste(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "paste icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Paste Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.971 4v5.331h7.59v8.206h7.432V44H23.782v-5.292H4.007V9.33h7.571V4zm12.082 16.477h-3.42v9.977H26.716v10.608h14.336V20.474zm-32.02-8.208H6.95v23.496h16.832v-7.384l9.84-9.98v-6.13h-2.335l.002 4.31H9.032zm25.662 9.232l-5.93 6.01 5.93.002zM12.85 12.27h-.877v1.373h16.376V12.27h-.404l.002.003H12.855zm13.18-5.327H14.516V9.33H26.03V6.94z"
  }));
};

var _default = SvgIconPaste;
exports.default = _default;